
//Run Loading
export const Loading = function (IsOpen) {
  if (IsOpen === 1) {
    document.getElementById("overlay").style.display = "block";
  } else {
    document.getElementById("overlay").style.display = "none";
  }
}

//TitleBar
export const TitleBar = function (Title) {
  document.title = Title;
  document.getElementById('breadcrumb').innerHTML = Title;

}
//CheckNetwork
export const CheckNetwork = function () {
  if (window.navigator.onLine) {
    return true;
  }
  return false;
}
//ShowAlert
export const ShowAlert = function (type, title, content) {
  let alerts = new CustomAlerts({
    autoclose: 0
  });
  alerts.alert({
    type: type,
    title: title,
    content: content,
    autoclose: 3000
  })
}
//ShowAlert
export const ReloadList = function () {
  document.getElementById('BtnSearch').click();
}

//TextValidate
export const TextValidate = function (Expressions, text) {

  if (Expressions != [] && Expressions != null) {
    for (let index = 0; index < Expressions.length; index++) {
      const element = Expressions[index];
      if (element.Expression == "required") {
        if (text == "" || text == null) {
          return element;
        }
      } else {
        var Reqular = element.Expression;
        if (!text.match(Reqular)) {
          return element;
        }
      }
    }
    return true;
  }
}


class CustomAlerts { constructor(e = {}) { this.delay = e.delay || 100, this.autoclose = "number" == typeof e.autoclose ? e.autoclose : 5e3, this.load() } load() { if (!document.querySelector(".sticky-alerts")) { let e = document.createElement("div"); e.className = "sticky-alerts", document.body.appendChild(e) } document.querySelector(".sticky-alerts").addEventListener("mouseenter", (e => { e.target.classList.add("userint") })), document.querySelector(".sticky-alerts").addEventListener("mouseleave", (e => { e.target.classList.remove("userint"), document.querySelectorAll(".sticky-alerts .alert").forEach((e => { this.autoClose(e, e.dataset.autoclose || this.autoclose) })) })) } alert(e = {}) { let t = e.title || "Alert", a = e.content || "", s = e.id || "", l = e.type || "primary", o = e.delay || this.delay, n = "number" == typeof e.autoclose ? e.autoclose : this.autoclose; document.querySelector(".sticky-alerts").offsetHeight > window.innerHeight && document.querySelector(".sticky-alerts .alert:last-child").remove(), setTimeout((() => { let e = document.createElement("div"); s && (e.id = s), e.className = "alert show alert-" + l, n != this.autoClose && (e.dataset.autoclose = n); let o = document.createElement("div"); o.className = "alert-header"; let r = document.createElement("div"); r.className = "title", r.textContent = t; let c = document.createElement("span"); if (c.className = "close", c.textContent = "x", c.addEventListener("click", (e => { e.target.parentElement.parentElement.classList.add("fadeOut"), setTimeout((() => { e.target.parentElement.parentElement.remove() }), 500) })), o.appendChild(r), o.appendChild(c), e.appendChild(o), a) { let t = document.createElement("div"); t.className = "content", t.innerHTML = a, e.appendChild(t) } document.querySelector(".sticky-alerts").prepend(e), setTimeout((() => { e.classList.add("fadeIn") }), 1), this.autoClose(e, n) }), o) } autoClose(e, t) { t >= 1 && setTimeout((() => { e.parentElement && !e.parentElement.classList.contains("userint") && (e.classList.add("fadeOut"), setTimeout((() => { e.remove() }), 300)) }), t) } }


export const RoleAccess = function (RoleNames) {
  var result = false;
  var UserRoles = localStorage.getItem("UserRoles");
  if (UserRoles) {
    for (let index = 0; index < RoleNames.split(",").length; index++) {

      if (UserRoles.includes(RoleNames.split(",")[index])) {
        result = true;
        break;
      } else {
        result = false;
      }
    }
  }
  return result;


}

export const ShamsiToMiladi = function (Shamsi) {

  var JalaliDate = {
    g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
  };

  JalaliDate.jalaliToGregorian = function (j_y, j_m, j_d) {
    j_y = parseInt(j_y);
    j_m = parseInt(j_m);
    j_d = parseInt(j_d);
    var jy = j_y - 979;
    var jm = j_m - 1;
    var jd = j_d - 1;

    var j_day_no =
      365 * jy + parseInt(jy / 33) * 8 + parseInt(((jy % 33) + 3) / 4);
    for (var ii = 0; ii < jm; ++ii)
      j_day_no += JalaliDate.j_days_in_month[ii];

    j_day_no += jd;

    var g_day_no = j_day_no + 79;

    var gy =
      1600 +
      400 *
      parseInt(
        g_day_no / 146097
      ); /* 146097 = 365*400 + 400/4 - 400/100 + 400/400 */
    g_day_no = g_day_no % 146097;

    var leap = true;
    if (g_day_no >= 36525) {
      /* 36525 = 365*100 + 100/4 */
      g_day_no--;
      gy +=
        100 *
        parseInt(g_day_no / 36524); /* 36524 = 365*100 + 100/4 - 100/100 */
      g_day_no = g_day_no % 36524;

      if (g_day_no >= 365) g_day_no++;
      else leap = false;
    }

    gy += 4 * parseInt(g_day_no / 1461); /* 1461 = 365*4 + 4/4 */
    g_day_no %= 1461;

    if (g_day_no >= 366) {
      leap = false;

      g_day_no--;
      gy += parseInt(g_day_no / 365);
      g_day_no = g_day_no % 365;
    }

    for (
      var i = 0;
      g_day_no >= JalaliDate.g_days_in_month[i] + (i == 1 && leap);
      i++
    )
      g_day_no -= JalaliDate.g_days_in_month[i] + (i == 1 && leap);
    var gm = i + 1;
    var gd = g_day_no + 1;

    gm = gm < 10 ? "0" + gm : gm;
    gd = gd < 10 ? "0" + gd : gd;

    return [gy, gm, gd];
  };

  var dateSplitted = Shamsi.split("/"),
    jD = JalaliDate.jalaliToGregorian(
      dateSplitted[0],
      dateSplitted[1],
      dateSplitted[2]
    );
  var jResult = jD[0] + "-" + jD[1] + "-" + jD[2];

  return jResult;

}









